import styled from 'styled-components';
import { spacer24, spacer16, screenSmMin } from '@spotify-internal/encore-foundation';
import { ButtonIcon } from "../ButtonIcon";
export default styled(ButtonIcon).withConfig({
  displayName: "CloseButton",
  componentId: "rgkg5m-0"
})(["border:1px solid transparent;margin-right:-1px;position:absolute;right:", ";top:50%;transform:translate(0,-50%);&:focus{border-color:currentColor;border-style:dotted;outline:none;}@media (min-width:", "){right:", ";}"], spacer16, screenSmMin, spacer24);